import {ReturnSequence} from "../components/calculator/RateModels";

export enum GrowthModel {
  Simple = "Simple",
  Aggressive = "Aggressive",
  Balanced = "Balanced",
  Moderate = "Moderate",
  Custom = "Custom"
}

export function getGrowthModelLabel(model: GrowthModel) {
  switch (model) {
    case GrowthModel.Simple:
      return "Simple Growth"
    case GrowthModel.Aggressive:
      return "Aggressive - 70/30 Stocks/Bonds"
    case GrowthModel.Balanced:
      return "Balanced - 60/40 Stocks/Bonds"
    case GrowthModel.Moderate:
      return "Moderate - 50/50 Stocks/Bonds"
    case GrowthModel.Custom:
      return "Custom"
  }
}

class GrowthStrategy {
  growthModel: GrowthModel
  returnSequence: ReturnSequence
  growthRate: number
  inflationRate?: number
  ignoreCustomGrowthRates: boolean
  ignoreCustomInflationRates?: boolean
  surplusAssetId?: string
  surplusAssetPercent?: number
  customModel?: number[]
  assetIncomeEnabled?: boolean

  constructor (data: any) {
    this.growthModel = data.growthModel ?? GrowthModel.Simple
    this.returnSequence = data.returnSequence ?? ReturnSequence.Historical
    this.growthRate = data.growthRate ?? 0.04
    this.inflationRate = data.inflationRate ?? 0.03
    this.ignoreCustomGrowthRates = data.ignoreCustomGrowthRates === true
    this.ignoreCustomInflationRates = data.ignoreCustomInflationRates === true
    this.surplusAssetId = data.surplusAssetId
    if (this.surplusAssetId) {
      this.surplusAssetPercent = data.surplusAssetPercent ?? 1
    } else {
      this.surplusAssetPercent = 0
    }
    this.customModel = data.customModel ?? []
    this.assetIncomeEnabled = data.assetIncomeEnabled ?? false
  }
}

export default GrowthStrategy